import { getUser } from "@lib/firestoreQueries";
import { clearUserCache, saveUserToCache, getUserFromCache } from "../../utils/userCacheUtils";

const autoLogin = async user => {
  try {
    const { providerData, uid } = user.toJSON();

    // Controlla se c'è una discrepanza con il localStorage
    const storedUserId = JSON.parse(localStorage.getItem("userId") || 'null');

    if (storedUserId && storedUserId !== uid) {
      console.warn(`⚠️ Discrepanza UID rilevata! Firebase: ${uid}, localStorage: ${storedUserId}`);
      console.log(`🔄 Aggiornamento localStorage con l'UID corretto da Firebase Auth`);

      // Pulisci la cache del vecchio UID per evitare conflitti
      console.log(`🧹 Pulizia cache per il vecchio UID: ${storedUserId}`);
      clearUserCache(storedUserId);
    }

    // Sempre sincronizza il localStorage con l'UID di Firebase Auth (fonte di verità)
    localStorage.setItem("userId", JSON.stringify(uid));

    let userInfo;
    try {
      userInfo = await getUser(uid);
    } catch (fetchError) {
      console.warn("Fetch Firestore fallito, tentativo dalla cache:", fetchError.message);
      // Fallback alla cache persistente per errori di rete
      const cached = getUserFromCache(uid);
      if (cached) {
        console.log("Dati utente recuperati dalla cache persistente");
        return { ...cached, uid, fromCache: true };
      }
      throw fetchError;
    }

    // Se non troviamo i dati dell'utente in Firestore, proviamo la cache
    if (!userInfo) {
      const cached = getUserFromCache(uid);
      if (cached) {
        console.log("Dati Firestore vuoti, uso cache persistente");
        return { ...cached, uid, fromCache: true };
      }
      console.error(`Dati utente non trovati in Firestore per UID: ${uid}`);
      throw new Error(`Dati utente non trovati per l'utente ${uid}. Potrebbe essere necessario rifare il login.`);
    }

    // Salva in cache persistente per uso futuro
    saveUserToCache(uid, userInfo);

    // Aggiungiamo l'UID ai dati dell'utente per sicurezza
    return { ...userInfo, uid };
  } catch (error) {
    console.error("Errore in autoLogin:", error);
    throw error;
  }
};

export default autoLogin;
